import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { Utility } from '../../../common/utility';
import { DialogService } from '../../../shared/services/dialog.service';
import { ClinicAccessComponent } from './clinic-access/clinic-access.component';
import { PatientInformationFormComponent } from './patient-information-form.component';
import { ManagePatientAccountService } from './manage-patient.service';
import { PatientModel } from '../../../models/consultation/patient.model';
import { ValidationService } from '../../../shared/services/validation.service';
import { ModifyPatientPopupComponent } from './modify-patient-popup.component';
import { AppConstants } from '../../../shared/constants/constants';
import { UserType } from '../../../shared/constants/permission';
import { AppMessages } from '../../../shared/constants/messages';
import { ok } from 'assert';
import { HttpResponse } from 'selenium-webdriver/http';
import { Validators } from '@angular/forms';
import { PatientInformationCopyComponent } from './patient-infomation-copy/patient-infomation-copy.component';

@Component({
    selector: 'patient-information',
    templateUrl: 'patient-information.component.html',
    providers: [ManagePatientAccountService]
})

export class PatientInformationComponent implements OnInit {
    @ViewChild('patient') patientChild;
    public klass = 'patientinformation';
    public isEdit = false; // button isEdit
    public id;
    public patientModel = new PatientModel();
    public isModifySuccess = false;
    public isBaseClinic = localStorage.getItem(AppConstants.localStorage.isBaseClinic) == 'true';
    // public tempEmail: string = null;
    constructor(
        public utility: Utility,
        public dialogService: DialogService,
        private activateRoute: ActivatedRoute,
        private router: Router,
        public managePatientAccountService: ManagePatientAccountService
    ) { }

    ngOnInit() {
        this.id = this.activateRoute.snapshot.paramMap.get('id');
        this.getPatientInfo();
        this.patientChild.patientInformationForm.disable(); // disable form
    }

    getPatientInfo(){
        this.managePatientAccountService.getPatientUser(this.id).subscribe(
            result => {
                if (!result) {
                    return;
                }

                const data = result.json();
                this.patientChild.patientModel = data;
                this.patientChild.patientInformationForm.controls['birthDay'].setValue(new Date(data['dateOfBirth']));
                if (data['isSeparateBillingAddress'] === true) {
                    this.patientChild.isSeparate = true;
                }
                // this.tempEmail = this.patientChild.patientModel.email;
                if (data['partyTypeId'].value === '1') {
                    this.patientChild.isGroup = true;
                    ValidationService.attachRequired(this.patientChild.patientInformationForm.controls['partyId'], []);
                }
                this.patientChild.patientModel.isEnableCreateMyTMBAccount = data.isEnableCreateMyTMBAccount;
                this.patientChild.patientInformationForm.controls['isCreateMyTMBAccount'].setValue(data.isCreateMyTMBAccount);

                this.patientChild.patientInformationForm.controls['userName'].setValue(data.userName);

                if (this.patientChild.patientInformationForm.controls['isCreateMyTMBAccount'].value === true || (this.patientChild.patientModel != null && this.patientChild.patientModel.isEnableCreateMyTMBAccount == false)) {
                    ValidationService.attachRequired(this.patientChild.patientInformationForm.controls['email'], [Validators.required, ValidationService.isValidEmail]);
                }
            }
        );
    }

    toggleEdit() {
        this.isEdit = true; // disabled button edit
        this.patientChild.isEdit = true; // isEdit in form
        this.patientChild.patientInformationForm.enable(); // enable form
        this.patientChild.patientInformationForm.controls['userName'].disable();
        this.patientChild.patientInformationForm.controls['patientREF'].disable();
        this.patientChild.patientInformationForm.controls['isCreateMyTMBAccount'].setValue(this.patientChild.patientModel.isCreateMyTMBAccount);
        if (this.patientChild.patientModel != null && this.patientChild.patientModel.isEnableCreateMyTMBAccount == false) {
            this.patientChild.patientInformationForm.controls['isCreateMyTMBAccount'].disable();
        }
        else if (this.patientChild.patientModel != null && this.patientChild.patientModel.isEnableCreateMyTMBAccount == true) {
            this.patientChild.patientInformationForm.controls['isCreateMyTMBAccount'].enable();
            ValidationService.removeRequired(this.patientChild.patientInformationForm.controls['email'], [ValidationService.isValidEmail]);
        }
    }

    editPatient() {
        this.managePatientAccountService.updatePatientAccount(this.id, this.patientChild.patientInformationForm.value).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.dialogService.openSuccessDialog({ message: data.message });
                    // update success flag to reload page
                    this.isModifySuccess = true;
                    this.enableCreateMyTMBAccount();
                }
        });
    }

    enableCreateMyTMBAccount() {
        this.managePatientAccountService.checkEnableMyTMBAccount(this.id).subscribe(result => {
            if (result) {
                const data = result.json();
                if (data) {
                    this.patientChild.patientInformationForm.controls['isCreateMyTMBAccount'].disable();
                    this.patientChild.patientInformationForm.controls['isCreateMyTMBAccount'].setValue(true);
                    this.patientChild.patientModel.isEnableCreateMyTMBAccount = false;
                }
                else {
                    this.patientChild.patientInformationForm.controls['isCreateMyTMBAccount'].setValue(false);
                    this.patientChild.patientModel.isEnableCreateMyTMBAccount = true;
                }
            }
        });

        this.managePatientAccountService.getPatientUser(this.id).subscribe(
            result => {
                if (!result) {
                    return;
                }

                const data = result.json();
                this.patientChild.patientInformationForm.controls['userName'].setValue(data.userName);
            }
        );
    }

    savePatientInformation() {
        /*if(this.patientChild.patientInformationForm.controls['isCreateMyTMBAccount'].value === true){
            this.patientChild.patientInformationForm.controls['isDisable'].setValue(false);
        }*/

        var email = this.patientChild.patientInformationForm.controls['email'].value;
        if (this.patientChild.patientInformationForm.controls['isCreateMyTMBAccount'].value === true &&
            (email == undefined || email == "")) {
            var message = "Please input Email.";
            this.dialogService.openErrorDialog({ message: message }).subscribe();
        }
        else {
            this.patientChild.ngForm.onSubmit();
            if (this.patientChild.patientInformationForm.valid) {
                this.patientChild.ngForm.onSubmit();
                if (this.patientChild.patientInformationForm.controls['partyTypeId'].value === 'Individual') {
                    this.patientChild.patientInformationForm.controls['partyId'].setValue('');
                }
                if (this.id) {
                    const dateOfBirth = this.utility.convertDateToString(this.patientChild.patientInformationForm.controls['birthDay'].value);
                    this.patientChild.patientInformationForm.controls['dateOfBirth'].setValue(dateOfBirth);
                    var firstname = this.patientChild.patientInformationForm.controls['firstName'].value.trim();
                    var surname = this.patientChild.patientInformationForm.controls['surName'].value.trim();
                    var middlename = this.patientChild.patientInformationForm.controls['middleName'].value;
                    if (middlename !== null && middlename !== undefined) {
                        middlename = middlename.trim();
                    }

                    //firstname = firstname.replace(/\s/g, '');
                    //surname = surname.replace(/\s/g, '');
                    this.patientChild.patientInformationForm.controls['surName'].setValue(surname);
                    this.patientChild.patientInformationForm.controls['firstName'].setValue(firstname);
                    this.patientChild.patientInformationForm.controls['middleName'].setValue(middlename);

                    var email = this.patientChild.patientInformationForm.controls['email'].value;
                    if ((this.patientChild.patientInformationForm.controls['isCreateMyTMBAccount'].value === true || (this.id != null && this.patientModel != null && this.patientModel.isEnableCreateMyTMBAccount == false) && email !== undefined && email !== "")) {
                        const confirmMessage = AppMessages.patient.addSameEmail;

                        const param = {
                            emailAddress: email,
                            patientId: this.id
                        };

                        this.managePatientAccountService.checkEmailExists(param).subscribe(
                            (c) => {
                                if (c) {
                                    const emailData = c.json();

                                    if (emailData != null && (this.id != emailData.id)) {
                                        this.dialogService.openConfirmationDialog({ message: confirmMessage }).subscribe(result => {
                                            if (result) {
                                                this.onSaveSucess();
                                            }
                                        });
                                    }
                                    else {
                                        this.onSaveSucess();
                                    }
                                }
                            });
                    }
                    else {
                        this.onSaveSucess();
                    }
                }
            }
        }
    }

    onSaveSucess() {
        this.editPatient();
        this.isEdit = false; // enabled button edit
        this.patientChild.isEdit = false; // isEdit in form
        this.patientChild.patientInformationForm.disable(); // disable form
        this.patientChild.patientInformationForm.controls['sendActivationEmail'].setValue(false);
    }

    openClinicAccess() {
        // this.dialogService.openComponentDialog(ClinicAccessComponent, '', {
        //     width: '80%',
        //     height: '500px'
        // });
        const data = {
            patientId: this.id
        };

        this.dialogService.openComponentDialog(ClinicAccessComponent, data);
    }

    copy(copyStyle) {
      const data = {
        patientId: this.id,
        copyStyle: copyStyle
    };
      this.dialogService.openComponentDialog(PatientInformationCopyComponent, data);
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-patient-user/patient-information.component.ts